/*
 * サブシステム名：マスタ管理
 * 機能名：自社銀行口座一覧
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'

const DdSearchList = () => import('@/components/DdSearchList')
const DdTextBox = () => import('@/components/DdCodeTextBox')
const DdSubHeader = () => import('@/components/DdSubHeader')

export default {
  name: 'MstJishaGinkoKozaList',
  mixins: [flowMixin],
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,
    conditions: {},
    modeKengen: 0
  }),
  components: {
    DdSearchList,
    DdTextBox,
    DdSubHeader
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      kubunList: 'DDMasters/msysKubun',
      kubunshubetsushuruiList: 'DDMasters/msysKubunShubetsuShurui'
    }),
    filteredRows () {
      return this.rows.map((elem) => {
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msyskubun', 'msyskubunshubetsushurui'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '金融機関コード', value: 'kinyuKikanCd' },
              { text: '金融機関名', value: 'kinyuKikanNm' },
              { text: '支店コード', value: 'kinyuKikanShitenCd' },
              { text: '支店名', value: 'kinyuKikanShitenNm' },
              { text: '口座種別', value: 'codeNm' },
              { text: '口座番号', value: 'kozaNo' },
              { text: '口座名義', value: 'kozaMeigiNm' },
              // { text: '外部連携用テキスト', value: 'gaibuRenkeiyoText' },
              { text: '銀行口座情報備考', value: 'ginkoKozaJohoBiko' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise(resolve => {
            self.conditions = {
              kinyuKikanNm: '',
              kinyuKikanShitenNm: '',
              kozaNo: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.searchText || ''
            self.rows = c.cache.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCMstJishaGinkoKoza/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              kinyuKikanNm: '',
              kinyuKikanShitenNm: '',
              kozaNo: ''
            }
            this.searchText = ''
            this.rows = []
            this.selected = []
            this.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onEditButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: this.selected[0].id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    }
  }
}
